<div class="spinner-container">
      <mat-card-content>
        <mat-progress-spinner class="example-margin2" [mode]="'indeterminate'" [diameter]="diamet"></mat-progress-spinner>
      </mat-card-content>
</div>

